function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable max-statements */
import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import icCloseIcon from 'assets/svg/ic_close.svg';
import bgCreateAccount from 'assets/img/bg_hero_V2.png';
import icInfo from 'assets/svg/ic_info.svg';
import { isEmail, isNumeric } from '@profile/src/utils/validations';
import { useTypedDispatch, useTypedSelector } from '@profile/src/redux/utils';
import { createAccount, resetErrorCreateAccount, sendCodeToEmail } from '@profile/src/redux/actions';
import CodeButton from './Components/CodeButton';
import { formatErrorMessage, openInNewTab, removeCountDownSendCode, setCountDownSendCode } from '../../utils';
import { AppError } from '@profile/src/redux/types';
import InputLabel from './Components/InputLabel';
import Button from '@profile/src/Components/Button';
import Modal from '@profile/src/Components/Modal';
import { CONTACT_SUPPORT_URL, TERMS_OF_USE_URL } from '@profile/src/constants';
import { logCreatAccountStart } from '@profile/src/utils/analytic';
import { useTestId } from '@wolffun/testable-id';
const LIST_ERROR_EMAIL = [AppError.EMAIL_NOT_EXIST, AppError.EMAIL_EXIST, AppError.EMAIL_INVALID];
const LIST_ERROR_CODE = [AppError.CODE_INVALID];

const CreateGameProfileModal = ({
  onClose,
  onCreateSuccess,
  onClickChangeStatus,
  isCreateAccount
}) => {
  const {
    generateTestIdProps
  } = useTestId();
  const dispatch = useTypedDispatch();
  const timeoutRef = React.useRef();
  const [email, setEmail] = React.useState('');
  const [code, setCode] = React.useState();
  const [isSentSuccess, setSentSuccess] = React.useState(false);
  const [emailError, setEmailError] = React.useState(AppError.NO_ERROR);
  const errorSendCode = useTypedSelector(state => state.sendCodeToEmail.error);
  const loadingSendCode = useTypedSelector(state => state.sendCodeToEmail.loading);
  const errorCreateAccount = useTypedSelector(state => state.createAccount.error);
  const loadingCreateAccount = useTypedSelector(state => state.createAccount.loading);
  React.useEffect(() => {
    if (isCreateAccount) logCreatAccountStart();
  }, []);

  const resetError = () => {
    timeoutRef.current && clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setEmailError(AppError.NO_ERROR);
      dispatch(resetErrorCreateAccount());
    }, 300);
  };

  const onChangeEmail = e => {
    setEmail(e.target.value);
    resetError();
  };

  const onChangeCode = e => {
    const {
      value
    } = e.target;

    if (!value) {
      setCode(undefined);
    }

    if (isNumeric(value)) {
      setCode(Number(value));
    }

    resetError();
  };

  const errorValue = errorSendCode || errorCreateAccount || emailError;
  const error = {
    email: LIST_ERROR_EMAIL.find(e => e === errorValue),
    code: LIST_ERROR_CODE.find(e => e === errorValue),
    common: LIST_ERROR_EMAIL.concat(LIST_ERROR_CODE).find(e => e === errorValue) ? AppError.NO_ERROR : errorValue
  };
  const [timestamp, setTimestamp] = React.useState(() => {
    const localTimestamp = localStorage.getItem('sendCodeTimestamp');

    if (isNumeric(localTimestamp)) {
      return Number(localTimestamp);
    }

    return undefined;
  });

  const validate = () => {
    if (!isEmail(email)) {
      setEmailError(AppError.EMAIL_INVALID);
      return false;
    }

    setEmailError(AppError.NO_ERROR);
    return true;
  };

  const onClickSendCode = async () => {
    if (!validate()) {
      return;
    }

    setSentSuccess(false);
    const isSuccess = await dispatch(sendCodeToEmail(email, isCreateAccount));

    if (isSuccess) {
      const now = Date.now();
      setCountDownSendCode(String(now));
      setTimestamp(now);
      setSentSuccess(true);
    }
  };

  const onClickCreateAccount = async () => {
    if (!validate()) {
      return;
    }

    if (code && email) {
      const isSuccess = await dispatch(createAccount(email, code, isCreateAccount));
      removeCountDownSendCode();
      isSuccess && onCreateSuccess();
    }
  };

  return /*#__PURE__*/React.createElement(Modal, _extends({}, generateTestIdProps('close-button'), {
    className: styles.backdrop
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("img", {
    draggable: false,
    className: styles.left,
    src: bgCreateAccount
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, isCreateAccount ? 'create game account' : 'link game account'), /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    className: styles.close
  }, /*#__PURE__*/React.createElement("img", {
    src: icCloseIcon
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(InputLabel, _extends({
    value: email,
    onChange: onChangeEmail,
    placeholder: "abc@gmail.com",
    label: "Email",
    type: "email",
    className: styles.email,
    error: !!error.email && /*#__PURE__*/React.createElement("span", {
      className: classNames(styles.textError, styles.emailError)
    }, formatErrorMessage(error.email), ' ', AppError.EMAIL_NOT_EXIST === error.email && /*#__PURE__*/React.createElement("span", {
      className: styles.txtCreate,
      onClick: () => {
        onClickChangeStatus(true);
        dispatch(resetErrorCreateAccount());
      }
    }, "Create new account"))
  }, generateTestIdProps('input-email'))), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapperCode
  }, /*#__PURE__*/React.createElement(InputLabel, _extends({
    type: "number",
    value: code,
    onChange: onChangeCode,
    label: "Enter code",
    className: styles.code,
    disabled: !!error.email || !isSentSuccess,
    error: error.code ? formatErrorMessage(error.code) : undefined
  }, generateTestIdProps('input-code'))), /*#__PURE__*/React.createElement(CodeButton, _extends({
    disabled: !!emailError || !email,
    className: styles.btnSendCode,
    timestamp: timestamp,
    onClick: onClickSendCode,
    loading: loadingSendCode
  }, generateTestIdProps('send-code')))), !!error.common && (error.common === AppError.USER_BANNED ? /*#__PURE__*/React.createElement("div", {
    className: styles.banned
  }, /*#__PURE__*/React.createElement("img", {
    src: icInfo,
    className: styles.infoIcon
  }), /*#__PURE__*/React.createElement("span", null, formatErrorMessage(error.common), "\xA0"), /*#__PURE__*/React.createElement("span", {
    onClick: () => openInNewTab(CONTACT_SUPPORT_URL),
    className: styles.contact
  }, "Contact Support")) : !!error.common && /*#__PURE__*/React.createElement("span", {
    className: styles.textError
  }, formatErrorMessage(error.common))), /*#__PURE__*/React.createElement(Button, _extends({
    disabled: !code || !email || !!errorValue,
    className: styles.btnCreate,
    title: isCreateAccount ? 'Create Account' : 'Link account',
    onClick: onClickCreateAccount,
    loading: loadingCreateAccount
  }, generateTestIdProps(isCreateAccount ? 'create-account-button' : 'link-account-button'))), /*#__PURE__*/React.createElement("span", {
    className: styles.desc
  }, 'By continuing, you agree to ', /*#__PURE__*/React.createElement("span", {
    onClick: () => openInNewTab(TERMS_OF_USE_URL),
    className: styles.text
  }, "Thetan Arena's Terms of Service"), ' and confirm that you have read ', /*#__PURE__*/React.createElement("span", {
    onClick: () => openInNewTab('https://doc.thetanarena.com/faqs/policy'),
    className: styles.text
  }, "Thetan Arena's Privacy Policy"), '.'), /*#__PURE__*/React.createElement("div", {
    className: styles.createAccount
  }, isCreateAccount ? 'You already have an account?' : 'Don’t have an account?', "\xA0", /*#__PURE__*/React.createElement("span", _extends({
    onClick: () => {
      onClickChangeStatus(!isCreateAccount);
      dispatch(resetErrorCreateAccount());
    }
  }, generateTestIdProps(isCreateAccount ? 'connect-now-button' : 'create-now-button')), isCreateAccount ? 'Connect now' : 'Create now'))))));
};

export default CreateGameProfileModal;